var a="@afe/pmm-sdk",e="2.0.18-beta.1";export{a as name,e as version};
